export default __webpack_public_path__ + "be245b4ac6d756dcc8529d2a5c2bf59f.svg";